import { render, staticRenderFns } from "./PdvClosedValuesTwo.vue?vue&type=template&id=5256b747"
import script from "./PdvClosedValuesTwo.vue?vue&type=script&lang=js"
export * from "./PdvClosedValuesTwo.vue?vue&type=script&lang=js"
import style0 from "./PdvClosedValuesTwo.vue?vue&type=style&index=0&id=5256b747&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports